import React, { useEffect } from "react";
import CodeConfirm from "./CodeConfirm";
import RegisterDetails from "./RegisterDetails";
import { useDispatch, useSelector } from "react-redux";
import { selectUserPending, resetSignInPage } from "slices/authSlice";

const CreateNewAccountForm = ({ postCreate }) => {
  const dispatch = useDispatch();
  const userPending = useSelector(selectUserPending);
  useEffect(() => () => dispatch(resetSignInPage()), [dispatch]);
  return (
    <>
      <hr className="hr-signUp" />
      <div className="slideContainer">
        <div className={userPending ? "formSlideLeft" : ""}>
          <RegisterDetails hidden={userPending} />
          <CodeConfirm postCreate={postCreate} />
        </div>
      </div>
    </>
  );
};

export default CreateNewAccountForm;
